<template>
  <div class="pro-bim">
    <h2 class="is-size-2 has-text-weight-semibold title has-text-dark">Procore</h2>
    <h3 class="is-size-3 has-text-weight-bold title line-height">Procore Submittals</h3>
    <h4 class="is-size-4 line-height  mb-3">
    {{ bimText.msg }}
    </h4>
    <button
      class="button has-background-black-bis has-text-white is-medium"
      v-permission="{permissionModule: 'app&projects', type: 'thirdPartyPlugins'}"
      @click="procoreOauth">{{ bimText.authButton }}</button>
  </div>
</template>
<script>
import { computed, onMounted, reactive, toRefs } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { isEmpty } from 'lodash';
export default ({
  name: 'ProcoreUser',
  setup() {
    const store = useStore();
    const router = useRouter();
    const data = reactive({
      isProcoreUser: false,
      edit: false,
    });

    const bimText = computed(() => {
      let msg = 'Enable Procore to link submittals.Changes will take effect immediately';
      let authButton = 'Enable Procore';
      if (data.isProcoreUser) {
        authButton = 'CHANGE';
        msg = 'Procore Viewing is currently enabled. '
          + 'To link Submittals to Materials, go to Project Settings.';
      }
      return { msg, authButton };
    });
    const toggleEdit = () => {
      data.edit = !data.edit;
    };
    const procoreOauth = () => {
      router.push({ name: 'procore-authorize', params: { oauth: 'authorize' } });
    };

    onMounted(async () => {
      await store.getters.userPromise;
      const user = store.state.userData;
      data.isProcoreUser = !isEmpty(user.procoreCredentials);
    });
    return {
      ...toRefs(data),
      bimText,
      toggleEdit,
      procoreOauth,
    };
  },
});
</script>
